import { component } from 'picoapp';

import { gsap } from 'gsap';

export default component((node: HTMLElement) => {
  const imageContainer = node.querySelector('[data-image-container]');
  const textElements = node.querySelectorAll('[data-text-animation-elem]');
  const imageNav = node.querySelector('[data-image-nav]');
  const tl = gsap.timeline();

  window.addEventListener('load', () => {
    if (window.innerWidth < 1024) {
      tl
        .to(imageContainer, {
          opacity: 1,
          duration: 0.8,
          ease: 'Power2.easeOut',
        })
        .to(imageNav, {
          opacity: 1,
          y: 0,
          duration: 0.8,
          ease: 'Power2.easeOut',
        }, '-=0.4');
      return;
    }

    tl
      .to(imageContainer, {
        opacity: 1,
        x: 0,
        duration: 0.8,
        ease: 'Power2.easeOut',
      })
      .to(textElements, {
        stagger: 0.1,
        opacity: 1,
        y: 0,
        duration: 0.3,
        ease: 'Power2.easeInOut',
      }, '-=0.4');
  });
});
